// react
import React from "react";
// seo
import Seo from "../../../features/seo/seo.tsx";
// form
import { useForm } from "react-hook-form";
// custom hook
import useSendData from "../../../hook/sendData.tsx";
// services
import { AdminLoginSevice } from "../../../services/admin/login/adminLogin.tsx";
// error handler
import { onError } from "../../../features/error/error.tsx";
// navigator
import { useNavigate } from "react-router-dom";
// icon
import { IconKey } from "@tabler/icons-react";
import { ToastContainer } from "react-toastify";

const AdminLogin = () => {
    const navigator = useNavigate();
    const { register, handleSubmit }: any = useForm<any>();
    let sendData;
    const { send, pending } = useSendData(sendData, AdminLoginSevice, navigator, '/dashboard/admin/plans', 'admin_token')
    const onSubmit = (data: any) => {
        send(data);
    }
    return (
        <>
            <Seo
                name="viraCompany"
                title="مادوند | ورود ادمین"
            />
            <section id="login" className="login-section container-fluid px-md-4">
                <div className="row h-100 align-items-center overflow-x-hidden">
                    <div className="col-md-4 order-md-0 order-1" data-aos='fade-left' data-aos-duration={'1500'}>
                        <form onSubmit={handleSubmit(onSubmit, onError)}>
                            <h5 className="card-title mb-4 fw-bold">
                                <IconKey className="me-2" />
                                ورود به پنل ادمین
                            </h5>
                            <fieldset className="form-floating">
                                <input type="text" id="username" className="form-control"
                                    placeholder="نام کاربری"
                                    {...register('username', { required: 'فیلد نام کاربری الزامی است.' })}
                                />
                                <label htmlFor="username" className="form-label">
                                    نام کاربری
                                </label>
                            </fieldset>
                            <fieldset className="form-floating mt-4">
                                <input type="text" id="password" className="form-control"
                                    placeholder="رمز عبور"
                                    {...register('password', { required: 'فیلد رمزعبور الزامی است.' })}
                                />
                                <label htmlFor="password" className="form-label">
                                    رمز عبور
                                </label>
                            </fieldset>
                            <button disabled={pending} className="btn btn-primary w-100 py-3 mt-4">
                                {pending ? 'در حال ارسال ... ' : 'ورود'}
                            </button>
                        </form>
                    </div>
                    <div className="col-md-8 order-md-1 order-0" data-aos='fade-right' data-aos-duration={'1500'}>
                        <img className="img-fluid" alt="login" src={require('./../../../assets/media/backgrounds/login.jpg')} />
                    </div>
                </div>
            </section>
            <ToastContainer/>
        </>
    )
}

export default AdminLogin;